//397511004789-jqbvtbva5ufqi5k75vbffdbu2d2e6gh2.apps.googleusercontent.com



if($('.googleCalendar').length){


    var currentLang = document.documentElement.lang || 'cs';
    var translations = {
        cs: {
            monthNames: ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'],
            dayNames: ['Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota', 'Neděle'],
            eventTitle: 'Volné termíny pro',
            noEvents: 'Žádné termíny nejsou obsazené',
            button: 'Domluvit termín',
            selectTime: 'Vyberte čas',
            fillOther: 'Vyplňte pole "Jiné", pokud jste tuto možnost vybrali.',
            enterName: 'Zadejte své jméno.',
            success: 'Formulář byl úspěšně odeslán, budeme vás kontaktovat.',
            error: 'Při odeslání nastala chyba, zkuste to prosím znovu.'
        },
        en: {
            monthNames: ['January','February','March','April','May','June','July','August','September','October','November','December'],
            dayNames: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            eventTitle: 'Available appointments for',
            noEvents: 'No appointments booked',
            button: 'Schedule appointment',
            selectTime: 'Select time',
            fillOther: 'Please fill in the "Other" field if selected.',
            enterName: 'Please enter your name.',
            success: 'Form submitted successfully, we will contact you.',
            error: 'An error occurred during submission, please try again.'
        }
    };



    var customCalendar = '<div class="header">'
    customCalendar +=    '<button id="prev"><i class="fas fa-chevron-left"></i></button>'
    customCalendar +=  '<h2 id="month-year"></h2>'
    customCalendar +=    '<button id="next"><i class="fas fa-chevron-right"></i></button>'
    customCalendar +=    '</div>'
    customCalendar +=    '<div id="calendar"></div>'
    customCalendar +=    '<div id="event-details">'
    customCalendar +=       '<span class="close"></span>'
    customCalendar +=        '<h2>' + translations[currentLang].eventTitle + ' <span id="selected-date"></span></h2>'
    customCalendar +=        '<ul id="event-list"></ul>'
    customCalendar +=        '<span class="btn btn-primary termin">' + translations[currentLang].button + '</span>'
    customCalendar +=    '</div>'
    $('.googleCalendar').html(customCalendar)
    var API_KEY = 'AIzaSyAoBzOAHKBmjBGgHTMXz3ytCM1YwbJucd4'; // Nahraďte vaším veřejným API klíčem
    var CALENDAR_ID = 'd52dfb142249812fd063dd7c7a011aac6199f4fae0b571cd44874b94ee973509@group.calendar.google.com'; // Nahraďte ID vašeho kalendáře
    var DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];
    var currentDate = new Date();

    function handleClientLoad() {
        gapi.load('client', initClient);
    }

    function initClient() {
        gapi.client.init({
            apiKey: API_KEY,
            discoveryDocs: DISCOVERY_DOCS,
        }).then(function () {
            renderCalendar();
        }, function(error) {
            console.error(JSON.stringify(error, null, 2));
        });
    }

    var minBookingDate = new Date();
minBookingDate.setDate(minBookingDate.getDate() + 3); // Nastaví minimální možný den rezervace na aktuální den +3
function getNextAvailableDate(startDate) {
    let tempDate = new Date(startDate);
    tempDate.setDate(tempDate.getDate() + 3);
    
    while (tempDate.getDay() === 6 || tempDate.getDay() === 0) { // Pokud je sobota nebo neděle
        tempDate.setDate(tempDate.getDate() + 1); // Posun na nejbližší pracovní den
    }
    
    return tempDate;
}

minBookingDate = getNextAvailableDate(minBookingDate);


    function renderCalendar() {
        var monthYear = $('#month-year');
        var calendar = $('#calendar');
        var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var daysInMonth = lastDay.getDate();
        var startDay = (firstDay.getDay() + 6) % 7; // Převedení na pondělí jako první den (0 - pondělí, 6 - neděle)

        monthYear.text(translations[currentLang].monthNames[firstDay.getMonth()] + ' ' + currentDate.getFullYear());


        calendar.empty();

        // Přidání názvů dnů
        translations[currentLang].dayNames.forEach(function(dayName) {
            calendar.append('<div class="day-name">' + dayName + '</div>');
        });

        // Funkce pro formátování data do formátu YYYY-MM-DD
        function formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, '0');
            var day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        // Přidání dnů z předchozího měsíce
        var prevMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        for (var i = startDay - 1; i >= 0; i--) {
            var prevMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, prevMonthLastDay - i);
            var day = $('<div class="day other-month"></div>').text(prevMonthDate.getDate());
            day.attr('data-date', formatDate(prevMonthDate));
            calendar.append(day);
        }
        function getMinBookingDate(startDate) {
            let tempDate = new Date(startDate);
            let count = 0;
            
            while (count < 1) {
                tempDate.setDate(tempDate.getDate() + 1);
                if (tempDate.getDay() !== 6 && tempDate.getDay() !== 0) { // Přeskočit víkendy
                    count++;
                }
            }
            
            return tempDate;
        }
        
        // Nastavení prvního možného dne k rezervaci
        let minBookingDate = getMinBookingDate(new Date());

        
        // Přidání dnů aktuálního měsíce
        for (var i = 1; i <= daysInMonth; i++) {
            var currentMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
            var formattedDate = formatDate(currentMonthDate);
            var day = $('<div class="day"></div>').text(currentMonthDate.getDate());
            day.attr('data-date', formattedDate);
        
            // Povolení klikání pouze na dny po minBookingDate (kromě víkendů)
            if (currentMonthDate >= minBookingDate && currentMonthDate.getDay() !== 6 && currentMonthDate.getDay() !== 0) {
                day.addClass('clickable');
            } else {
                day.addClass('disabled-day');
            }
        
            calendar.append(day);
        }

        // Přidání dnů z následujícího měsíce
        var remainingDays = 7 - (calendar.children().length % 7);
        if (remainingDays < 7) {
            for (var i = 1; i <= remainingDays; i++) {
                var nextMonthDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i);
                var day = $('<div class="day other-month"></div>').text(nextMonthDate.getDate());
                day.attr('data-date', formatDate(nextMonthDate));
                calendar.append(day);
            }
        }

        // Označení dnů s událostmi
        gapi.client.calendar.events.list({
            'calendarId': CALENDAR_ID,
            'timeMin': firstDay.toISOString(),
            'timeMax': new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1).toISOString(),
            'showDeleted': false,
            'singleEvents': true,
            'orderBy': 'startTime'
        }).then(function(response) {
            var events = response.result.items;
            events.forEach(function(event) {
                var eventDate = formatDate(new Date(event.start.dateTime || event.start.date));
                $('.day').each(function() {
                    if ($(this).attr('data-date') === eventDate) {
                        $(this).addClass('with-event');
                    }
                });
            });
        });

        $('.day').click(function() {
            var dateStr = $(this).attr('data-date');
            var selectedDate = new Date(dateStr);
            if (selectedDate >= minBookingDate && selectedDate.getDay() !== 6 && selectedDate.getDay() !== 0) {
                showEventDetails(dateStr);
            }
        });
        $('.day.clickable').click(function () {
            var dateStr = $(this).attr('data-date');
            showEventDetails(dateStr); // Otevře detaily událostí
        });
    }

    function showEventDetails(dateStr) {
        gapi.client.calendar.events.list({
            'calendarId': CALENDAR_ID,
            'timeMin': new Date(dateStr + 'T10:00:00Z').toISOString(),  // Začátek dne od 10:00
            'timeMax': new Date(dateStr + 'T17:00:00Z').toISOString(),  // Konec dne do 17:00
            'showDeleted': false,
            'singleEvents': true,
            'orderBy': 'startTime'
        }).then(function(response) {
            console.log(response.result)
            var events = response.result.items;
            var eventList = $('#event-list');
            var selectedDate = $('#selected-date');
            eventList.empty();
            var options = {day:'numeric',month:'numeric',year:'numeric'};
            selectedDate.text(new Date(dateStr).toLocaleDateString('cs-CZ', options));
    
            // Zjistíme, které hodiny jsou obsazeny
            var occupiedBlocks = new Set();
            if (events.length > 0) {
                console.log(events)
                events.forEach(function(event) {
                    if (event.start.dateTime && event.end.dateTime) {
                        var startHour = new Date(event.start.dateTime).getHours();
                        var endHour = new Date(event.end.dateTime).getHours();
                        
                        for (var i = startHour; i < endHour; i++) {
                            occupiedBlocks.add(i);
                        }
                    }
                });
            }
    
            // Vypíšeme bloky mezi 10:00 a 17:00 s rozlišením obsazených a volných
            for (var hour = 10; hour < 17; hour++) {
                var start = hour + ':00';
                var end = (hour + 1) + ':00';
                var li;
    
                if (occupiedBlocks.has(hour)) {
                    li = '<li class="occupied hide">'+start+' - '+end+'</li>';
                } else {
                    li = '<li class="available" time="'+start+' - '+end+'">'+start+' - '+end+'</li>';
                }
    
                eventList.append(li);
            }
    
            if (eventList.children().length === 0) {
                eventList.append('<li>' + translations[currentLang].noEvents + '</li>');
            }
    
            $('#event-details').addClass('openIt');
            $('.customContactCalendar .customContactCalendarForm')
        });
    }

    $('#prev').click(function() {
        currentDate.setMonth(currentDate.getMonth() - 1);
        renderCalendar();
    });

    $('#next').click(function() {
        currentDate.setMonth(currentDate.getMonth() + 1);
        renderCalendar();
    });
    $(document).on('click', '#event-details .close', function(){
        $(this).closest('#event-details').find('ul').empty()
        $(this).closest('#event-details').removeClass('openIt')
    })

    $('html').on('click', '.customLabelKind', function(){
       $(this).toggleClass('activeLabel')
       if($(this).attr('data-value') === 'Jiné'){
            $(this).closest('.formRow').find('.jineinput').slideToggle()
       }
    })

    $(document).on('click', '#event-details .termin', function(){
        $.colorbox({
            html: '<div class="customContactCalendar">'+$('footer#footer .customContactCalendar').html()+'</div>',
            width: 450,
            maxWidth: "95%",
            height: 450,
            maxHeight: "95%",
            className: "customContactCalendar",
            onComplete: function() {
                $('#event-list .available').each(function(){
                    $('.customContactCalendarForm #time').append('<option value="'+$(this).attr('time')+'">'+$(this).attr('time')+'</option>')
                })
                $('.customContactCalendarForm #time option').first().attr('disabled', 'disabled')
            },
            onClosed: function(){
                $('.customContactCalendarForm #time option').remove()
                $('.customContactCalendarForm #time').append('<option value="">Vyberte čas</option>')
            }
        })
    })

    $(document).on('click', '#event-details #event-list>li', function(){
        var time = $(this).attr('time')
        var availability = $(this).hasClass('available')
        $.colorbox({
            html: '<div class="customContactCalendar">'+$('footer#footer .customContactCalendar').html()+'</div>',
            width: 450,
            maxWidth: "95%",
            height: 450,
            maxHeight: "95%",
            className: "customContactCalendar",
            onComplete: function() {
                var selectedDate = $('#selected-date').text();
                $('#event-list .available').each(function(){
                    $('.customContactCalendarForm #time').append('<option data-date="'+selectedDate.trim()+' - '+$(this).attr('time')+'" value="'+$(this).attr('time')+'">'+$(this).attr('time')+'</option>')
                });

               /* $('.customContactCalendarForm #time option').first().attr('disabled', 'disabled')
                // např. 15. 4. 2024
                $('#event-list .available').each(function(){
                    var timeSlot = $(this).attr('time'); // např. 10:00 - 11:00
                    console.log(timeSlot)
                    var formattedOption = timeSlot + ' (' + selectedDate + ')';
                    var valueToSend = selectedDate + ' - ' + timeSlot;

                    $('.customContactCalendarForm #time').append('<option value="'+valueToSend+'">'+timeSlot+'</option>');
                });*/

                if(availability){
                    if (time) {
                        $('.customContactCalendarForm #time').val(time);
                    };
                }
                else{

                }
                
                $('.customContactCalendarForm #time option').first().attr('disabled', 'disabled')
            },
            onClosed: function(){
                $('.customContactCalendarForm #time option').remove()
                $('.customContactCalendarForm #time').append('<option value="">Vyberte čas</option>')
            }
        })
    })


    $(document).ready(function() {
        handleClientLoad();
    });

    $(document).on('submit', '.customContactCalendarForm', function(e) {
        e.preventDefault();
        $(this).addClass('loading-form');
        
        var selectedItems = [];
        var isValid = true;
    
        // Shromáždění dat z formuláře
        $('.customLabelKind.activeLabel').each(function() {
            var itemValue = $(this).data('value');
            var inputField = $(this).next('input.jineinput');
            if (inputField.length > 0 && inputField.val().trim() === '') {
                showMessage(translations[currentLang].fillOther, 'error', '', false, true);
                isValid = false;
            } else if (inputField.length > 0) {
                selectedItems.push(itemValue + ': ' + inputField.val());
            } else {
                selectedItems.push(itemValue);
            }
        });
    
        var formName = $(this).find('#name').val();
        var formEmail = $(this).find('#email').val();
        var formTel = $(this).find('#telphone').val();
        var formtime = $(this).find('#time option:selected').attr('data-date');
        var formPlace = $(this).find('#place option:selected').val();
        var formmessage = $(this).find('#message').val();
    
        // Validace vstupů
        if (!formtime || formtime === '') {
            showMessage(translations[currentLang].selectTime, 'error', '', false, true);
            isValid = false;
        }
        if (!formName || formName.trim() === '') {
            showMessage(translations[currentLang].enterName, 'error', '', false, true);
            isValid = false;
        }
       
    
        if (!isValid) {
            $(this).removeClass('loading-form');
            return;
        }
    
        // Vytvoření FormData
        var formdata = new FormData();
        formdata.append("name", formName);
        formdata.append("email", formEmail);
        formdata.append("phone", formTel);
        formdata.append("time", formtime);
        formdata.append("kind", selectedItems.join(', '));
        formdata.append("place", formPlace);
        formdata.append("message", formmessage);
    
        // Odeslání dat pomocí fetch
        fetch("https://tools.shopcode.cz/e-mail_sender/zlatnictviSalabaCalendar/www/", {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(function(result) {
                if (result.status === 'ok') {
                    showMessage(translations[currentLang].success, 'success', '', false, true);
                } else {
                    showMessage(translations[currentLang].error, 'error', '', false, true);
                }
                $('.customContactCalendarForm').removeClass('loading-form');
            })
            .catch(function(error) {
                console.error('Error:', error);
                showMessage(translations[currentLang].error, 'error', '', false, true);
                $('.customContactCalendarForm').removeClass('loading-form');
            });
    });
}